import React from 'react';

export default function Datenschutz() {
  return (
    <div className="min-h-screen py-20 px-4 bg-background">
      <div className="max-w-4xl mx-auto bg-white p-10 rounded-xl border border-border shadow-sm">
        <h1 className="text-4xl font-bold text-primary mb-8 border-b border-border pb-4">Datenschutzerklärung</h1>
        <div className="space-y-8 text-primary leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold mb-4">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-lg font-semibold mb-2">Allgemeine Hinweise</h3>
            <p className="text-muted-foreground mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-bold mb-4">2. Verantwortlicher</h2>
            <p className="text-muted-foreground mb-2">Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
            <div className="bg-slate-50 p-4 rounded-md border border-border font-medium">
              <p>ENVISU GmbH</p>
              <p>Dankwartsgrube 51</p>
              <p>23552 Lübeck</p>
              <p className="mt-2">Vertreten durch: Bernd Spautz</p>
              <p>E-Mail: kontakt@envisu-gmbh.com</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">3. Datenerfassung auf dieser Website</h2>
            <h3 className="text-lg font-semibold mb-2">Bewerberdaten</h3>
            <p className="text-muted-foreground mb-4">
              Wenn Sie sich über unsere Website als Tester bewerben, erheben wir Daten (Name, E-Mail-Adresse, Telefonnummer). Diese werden ausschließlich zur Bearbeitung Ihrer Bewerbung genutzt und über sichere Kanäle verarbeitet.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">4. Externe Dienste und Hosting</h2>
            <h3 className="text-lg font-semibold mb-2">Calendly & E-Mail-Versand</h3>
            <p className="text-muted-foreground">
              Zur Terminvereinbarung für Bewerbungsgespräche nutzen wir den Dienst Calendly sowie einen eigenen SMTP-Server für den E-Mail-Versand. Dabei werden Ihre eingegebenen Daten (Name, E-Mail) zum Zwecke der Terminorganisation verarbeitet.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}